import React from 'react'
import {Modal, Grid , GridColumn, GridRow, Container, ModalHeader, ModalDescription, ModalContent, ModalActions, Button, Image,Header } from "semantic-ui-react"
import ComentForm from './../ModalPublicasion /ComentForm';
import Comments from './Comments/Comments';
import Actions from "./Actions/Actions"
import { Link } from 'react-router-dom';
//import { each, map } from 'lodash';
//import { GET_PUBLICS } from '../../gql/publication';
//import { useQuery } from '@apollo/client';
import ActionsVent from "./ActionsVent/ActionsVent"
import TitlePublic from './titlepublic';
import Public from '../Publications/public/Public';
import Whats from './Whats';
import "./ModalPublication.scss";
import { useState } from "react"





export default function ModalPubication(props) {
    const {show,setShow, publication ,getPublics, publi, id } = props;
    //console.log(getPublics)
    //console.log(publication)

   
const onClose = () => setShow (false);
const [open, setOpen] = useState(false)


  return (
<Modal open={show} onClose={onClose}  size='fullscree' className='modal_p'  mobile={16}   >

<ModalHeader>{publication.title}</ModalHeader>
     
<Grid six wide tablet eight  computer column>  
          
            <GridColumn className='modal_p_left' mobile={16}   computer={8}> 
              <ModalContent image>

               <Image size='fullscreen'  src = {publication.file} />
                
                 </ModalContent>
                 <Actions publication={publication} getPublics= {getPublics}   /> 
                  
               
            </GridColumn>

            

                 

            <GridColumn className='modal_p_right' mobile={16} computer={8}    > 
             
            <ModalDescription>
            <Comments publication= {publication} getPublics= {getPublics}/>
          
        </ModalDescription>
            
            

             <ComentForm publication= {publication} getPublics= {getPublics}  />

            



            </GridColumn>



        </Grid>

        <ModalActions>
        <Button color='black' onClick={() => setShow(false)}>
          Cerrar ❌
          
        </Button>

        <Link to = {`/Publication/${publication._id}`}>
        <Button
          content="Publicacion"
          labelPosition='right'
          icon='angle right'
         
          positive
        />
        </Link>
      </ModalActions>

        
     
    </Modal>
  
  );
}